// Used to Create/Edit Quote
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { GetQuoteApiResultModel } from "@WhiteCap/Store/Service/OsnQuotes/OsnQuotesApiModels";
import { getQuoteService } from "@WhiteCap/Store/Service/OsnQuotes/OsnQuotesServices";

export interface CreateQuoteApiParameter extends ApiParameter {
    quoteNumber: string;
    onError?: (message: string) => void;
    onSuccess?: (quoteId?: string) => void;
}
type HandlerType = CustomApiHandler<CreateQuoteApiParameter, GetQuoteApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/OsnQuote/BeginGetQuoteDataLoad",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const { quoteNumber } = props.apiParameter;
    const result = await getQuoteService(quoteNumber);
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter?.onSuccess(result.result.quoteId);
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/OsnQuote/GetQuoteDataLoadError",
        });
        return false;
    }
};

export const DispatchCompleteCrateQuoteDataLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/OsnQuote/CompleteGetQuoteDataLoad",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteCrateQuoteDataLoad];

const osnGetQuote = createHandlerChainRunner(chain, "OsnGetQuote");
export default osnGetQuote;
